import { render, staticRenderFns } from "./commentsAndNotifications.vue?vue&type=template&id=0b69d663&"
import script from "./commentsAndNotifications.vue?vue&type=script&lang=js&"
export * from "./commentsAndNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports